import React, {
  memo,
  useRef,
  useState,
  useEffect,
  useLayoutEffect,
} from 'react';
import Slider from 'react-slick';
import { useHistory } from 'react-router-dom';

import { getThumbnail, generateDetailUrl, getDetailPoster } from '../../utils';
import { Loading } from '../../components';
import { CAROUSEL_ITEM_THUMBNAIL } from '../../config/Thumbnail';
import { useSelector } from 'react-redux';
import { BlockUnblockModal } from '..';
import { isBlockBlockedProfile } from '../../redux/actions/auth';
import { authPopup } from '../../redux/actions/auth';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './styles.css';
import analytic, {
  analyticEvents,
  analyticTypes,
} from '../../service/analytic';

import icArrowBack from '../../assets/ic-arrow-back.svg';
import ContentDetail from './ContentDetail';
import ContentClipstDetail from './ContentClipsDetail';
import ContenLiveDetailTop from './ContentLiveDetailTop';
import ContentLiveDetailMiddle from './ContentLiveDetailMiddle';

import imgBanner1 from '../../assets/dummy/img-banner1.svg';
import ContentCampaignBanner from './ContentCampaignBanner';
import { useDispatch } from 'react-redux';

const CarouselItemComponents = ({
  item,
  index,
  handleClickDetail,
  checkBlockUnblock,
}) => {
  switch (item.type) {
    case 'clips':
      return (
        <ContentClipstDetail
          item={item}
          index={index}
          handleClickDetail={handleClickDetail(item, index)}
          checkBlockUnblock={checkBlockUnblock}
        />
      );

    case 'live':
      return (
        <ContenLiveDetailTop
          item={item}
          index={index}
          handleClickDetail={handleClickDetail(item, index)}
        />
      );

    case 'campaign':
      return <ContentCampaignBanner item={item} index={index} />;

    default:
      return (
        <ContentDetail
          item={item}
          index={index}
          handleClickDetail={handleClickDetail(item, index)}
        />
      );
  }
};

const CarouselItem = memo(
  ({ item, index, handleClickDetail, checkBlockUnblock }) => {
    const thumbnail = getDetailPoster(item);

    return (
      <div key={item.id} className='carousel-wrapper'>
        <img
          src={item.type === 'live' ? imgBanner1 : thumbnail}
          alt='background-poster'
        />
        <div className='detail-wrapper'>
          <div className='detail'>
            <CarouselItemComponents
              {...{ item, index, handleClickDetail, checkBlockUnblock }}
            />
          </div>
          <div className='item-thumbnail'>
            <img
              src={item.type === 'live' ? imgBanner1 : thumbnail}
              alt='thumbnail'
              onClick={handleClickDetail(item, index)}
            />
          </div>
        </div>
      </div>
    );
  }
);

const CarouselMiddleItem = memo(
  ({ item, index, handleClickDetail, checkBlockUnblock }) => {
    const thumbnailRef = useRef();
    const [width, setSize] = useState(0);
    useLayoutEffect(() => {
      function updateSize() {
        setSize(window.innerWidth);
      }
      window.addEventListener('resize', updateSize);
      updateSize();
      return () => window.removeEventListener('resize', updateSize);
    }, []);

    useEffect(() => {
      const onResize = (e) => {
        setTimeout(() => {
          const slickDots = document.querySelector(
            ".carousel-container[data-carousel-type='middle'] .slick-slider .slick-dots"
          );
          const thumbnailClientRect =
            thumbnailRef?.current?.getBoundingClientRect();
          const slickDotsClientRect = slickDots?.getBoundingClientRect();
          if (thumbnailClientRect && slickDotsClientRect) {
            const updatedThumbnailRect =
              thumbnailClientRect.width / 2 +
              80 -
              slickDotsClientRect.width / 2;
            slickDots.style.left = updatedThumbnailRect + 'px';
            slickDots.style.bottom = '0px';
          }
        }, 500);
      };

      onResize();
    }, [item, width]);

    return (
      <div key={item.id} className='carousel-middle-wrapper'>
        <div ref={thumbnailRef} className='item-thumbnail-middle'>
          <img
            src={item?.thumbnail}
            alt='thumbnail'
            onClick={() => handleClickDetail(item, index)}
            // style={{
            //   '--c': thumbnailRect,
            // }}
          />
        </div>
        <div
          className='detail-middle-wrapper'
          onClick={() => handleClickDetail(item, index)}
        >
          <ContentLiveDetailMiddle
            item={item}
            index={index}
            checkBlockUnblock={checkBlockUnblock}
          />
        </div>
      </div>
    );
  }
);

function Carousel({ data, onChannelSelected, type = '' }) {
  const slider = useRef();
  const [focus, setFocus] = useState(0);
  const history = useHistory();

  const dispatch = useDispatch();
  const { token, user } = useSelector((state) => state.auth);
  const { trackLiveshowReminderId } = useSelector((state) => state.playlist);

  const [isTriggerBlockModal, setTriggerBlockModal] = useState(false);
  const [blockType, setBlockType] = useState('block');
  const [profile, setProfile] = useState(null);

  const checkBlockUnblock = async (data) => {
    if (!token && !user) {
      dispatch(authPopup.show());
      return true;
    }
    const res = await dispatch(
      isBlockBlockedProfile(data?.profile?.accountId, data?.profile?.id)
    );
    if (res?.data?.status === 'BLOCKING') {
      setProfile(data.profile);
      setBlockType('unblock');
      setTriggerBlockModal(true);
      return true;
    }
    if (res?.data?.status === 'BLOCKED') {
      setProfile(data.profile);
      setTriggerBlockModal(true);
      setBlockType('access');
      return true;
    }

    return false;
  };

  const onCloseBlockModal = (type) => {
    if (type === 'cancel') {
      setTriggerBlockModal(false);
      setProfile(null);
    }
    setTriggerBlockModal(false);
  };

  const handleClickItem = (old, newIn) => {
    slider.current.slickGoTo(newIn);
    setFocus(newIn);
  };

  //const user = useSelector((state) => state.auth && state.auth.user);

  const ArrowButton = ({ className, onClick, style }) => {
    return (
      <div className={`${className} custom-arrow`} onClick={onClick}>
        <img src={icArrowBack} alt='arrow' />
      </div>
    );
  };

  const settings = {
    className: 'center',
    infinite: true,
    slidesToShow: 1,
    beforeChange: handleClickItem,
    speed: 500,
    focusOnSelect: true,
    dots: true,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 5000,
    cssEase: 'cubic-bezier(0.215, 0.61, 0.355, 1)',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          centerPadding: '20%',
        },
      },
      {
        breakpoint: 500,
        settings: {
          centerMode: false,
        },
      },
    ],
    nextArrow: <ArrowButton />,
    prevArrow: <ArrowButton />,
  };

  useEffect(() => {
    if (type === 'middle' && trackLiveshowReminderId) {
      settings.initialSlide = data.items.findIndex(
        (item) => item.id === trackLiveshowReminderId
      );
    }
  }, [trackLiveshowReminderId, type, data.items, settings]);
  if (!data || (!data.items && !type !== 'middle')) {
    return <Loading height='50vh' />;
  }

  const handleClickDetail = (item, index) => async () => {
    const paramsAnalytic = {
      itemID: item.id,
      type: item.type,
      title: item.titleLocalized,
    };
    analytic(analyticTypes.event, analyticEvents.CATALOGUE.SELECT_CAROUSEL, {
      params: paramsAnalytic,
      user,
    });

    if (index !== focus) return;
    if (item.url === 'https://genflix.co.id/live-shows') {
      window.location.href = `https://genflix.co.id/live-shows`;
      return;
    }
    if (item.type === 'stream' || item.type === 'webview') {
      onChannelSelected(item);
    } else {
      if (token) {
        const res = await checkBlockUnblock(item);
        if (res) return;
      }

      history.push(generateDetailUrl(item));
    }
  };

  const handleClickUpcomingDetails = async (item) => {
    history.push(
      `/live-show/${item.latestShow.id}?isUpComing=${true}&startedAt=${
        item?.startedAt
      }&finishedAt=${item?.finishedAt}&upcomingShowId=${item.id}`
    );
  };

  if (data.items.length === 1 && type !== 'middle') {
    const item = data.items[0];
    const thumbnail = getThumbnail(item, CAROUSEL_ITEM_THUMBNAIL);

    return (
      <div key={item.id} className='carousel-wrapper'>
        <img src={thumbnail} alt='background-poster' />
        <div className='detail-wrapper'>
          <div className='detail'>
            <CarouselItemComponents
              {...{ item, index: 1, handleClickDetail }}
            />
          </div>
          <div className='item-thumbnail'>
            <img
              src={thumbnail}
              alt='thumbnail'
              onClick={handleClickDetail(item, 1)}
            />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className='carousel-container' data-carousel-type={type}>
      {type && type === 'middle' ? (
        <>
          <h1 className='title-upcoming-live'>Upcoming Live</h1>
          <Slider ref={slider} {...settings}>
            {data.items.map((item, index) => {
              return (
                <CarouselMiddleItem
                  key={item.id}
                  item={item}
                  index={index}
                  checkBlockUnblock={checkBlockUnblock}
                  handleClickDetail={(item) => handleClickUpcomingDetails(item)}
                  type={type}
                />
              );
            })}
          </Slider>
        </>
      ) : (
        <Slider ref={slider} {...settings}>
          {data.items.map((item, index) => {
            return (
              <CarouselItem
                key={item.id}
                item={item}
                index={index}
                handleClickDetail={handleClickDetail}
                checkBlockUnblock={checkBlockUnblock}
              />
            );
          })}
        </Slider>
      )}
      {profile && (
        <BlockUnblockModal
          profile={profile}
          blockType={blockType}
          isTriggered={isTriggerBlockModal}
          onClose={onCloseBlockModal}
        />
      )}
    </div>
  );
}

export default Carousel;
